<div *ngIf="collectionSize > noPerPage">
  <div
    class="col-md-12"
    style="text-align: center"
    [ngStyle]="
      elementStyle ? { 'margin-top': '-15px' } : { 'margin-top': '0px' }
    "
  >
    <ngb-pagination
      [collectionSize]="collectionSize"
      [pageSize]="noPerPage"
      [disabled]="disabled"
      [(page)]="page"
      [maxSize]="maxSize"
      [rotate]="true"
      (pageChange)="pageChanged()"
    ></ngb-pagination>
  </div>
</div>
